import { store } from '@/store/store'
import axios from 'axios'
import config from '../config'

const instance = () =>
  axios.create({
    baseURL: `${config.serverUrl}`,
    timeout: 30000,
    headers: {
      AUTHORIZATION: store.getters.securityToken
    }
  })

const atomicboyApi = {
  countUserLevel: (chapter) => {
    return instance().get(`/countUserLevel?chapter=${chapter}`)
  },
  userListByLevel: (params) => {
    return instance().get('/userListByLevel', { params })
  },
  falseQuestionReport: (data) => {
    return instance().post('/falseQuestionReport', data)
  }
}
export default atomicboyApi



// WEBPACK FOOTER //
// ./src/api/atomicboy.js